import React from 'react';

const CartSkeleton = () => {
  return (
    <div className="max-w-6xl mx-auto pt-20 p-4 animate-pulse">
      <h2 className="text-3xl font-bold mb-6">Your Cart</h2>
      <div className="flex flex-col lg:flex-row gap-6">
        {/* Cart Items */}
        <div className="flex-1 bg-white rounded shadow p-4 space-y-4">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex gap-4 items-center">
              <div className="w-24 h-24 bg-gray-200 rounded" />
              <div className="flex-1 space-y-2">
                <div className="w-3/4 h-4 bg-gray-200 rounded" />
                <div className="w-1/2 h-3 bg-gray-200 rounded" />
                <div className="w-1/3 h-3 bg-gray-200 rounded" />
                <div className="w-24 h-4 bg-gray-300 rounded" />
              </div>
              <div className="w-16 h-4 bg-gray-200 rounded" />
            </div>
          ))}
        </div>

        {/* Summary */}
        <div className="w-full lg:w-1/3 bg-white rounded shadow p-4 space-y-4 h-fit">
          <div className="w-1/2 h-5 bg-gray-300 rounded" />
          <div className="w-full h-4 bg-gray-200 rounded" />
          <div className="w-3/4 h-4 bg-gray-200 rounded" />
          <div className="w-full h-4 bg-gray-200 rounded" />
          <div className="w-1/2 h-6 bg-gray-300 rounded" />
          <div className="w-full h-10 bg-gray-400 rounded mt-4" />
        </div>
      </div>
    </div>
  );
};

export default CartSkeleton;
